import classNames from 'classnames';

import buttonStyle from '../../Button/button.module.css';
import style from './loading.module.css';

interface Props {
  className?: string;
}

const Loading = ({ className }: Props) => (
  <svg
    className={classNames(
      className,
      style.loading,
      buttonStyle.loading,
    )}
    height="18"
    viewBox="0 0 180 200"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    {'<!-- Animated SVG Preloaders by SVGBackgrounds.com -->'}
    {'<!-- https://www.svgbackgrounds.com/elements/animated-svg-preloaders/ -->'}
    <circle
      cx="40"
      cy="100"
      fill="currentColor"
      r="15"
      stroke="currentColor"
      strokeWidth="15"
    >
      <animate
        attributeName="opacity"
        begin="-.4"
        calcMode="spline"
        dur="2"
        keySplines=".5 0 .5 1;.5 0 .5 1"
        repeatCount="indefinite"
        values="1;0;1;"
      />
    </circle>
    <circle
      cx="100"
      cy="100"
      fill="currentColor"
      r="15"
      stroke="currentColor"
      strokeWidth="15"
    >
      <animate
        attributeName="opacity"
        begin="-.2"
        calcMode="spline"
        dur="2"
        keySplines=".5 0 .5 1;.5 0 .5 1"
        repeatCount="indefinite"
        values="1;0;1;"
      />
    </circle>
    <circle
      cx="160"
      cy="100"
      fill="currentColor"
      r="15"
      stroke="currentColor"
      strokeWidth="15"
    >
      <animate
        attributeName="opacity"
        begin="0"
        calcMode="spline"
        dur="2"
        keySplines=".5 0 .5 1;.5 0 .5 1"
        repeatCount="indefinite"
        values="1;0;1;"
      />
    </circle>
  </svg>
);

export default Loading;
